<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
<footer :class="classes" class="the-footer flex-wrap justify-between">
  <p>
    <span>Starling Minds &copy;</span>
    <span>{{ new Date().getFullYear() }} </span>
    <span class="hidden sm:inline-block">, All rights Reserved</span>
  </p>
</footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String
    }
  }
};
</script>
